import { IFile } from "../domain/models/File";
import { IEvents } from "../domain/models/Events";
import { IEventsTranslation } from "../domain/models/EventsTranslation";
import { BaseModelImpl } from "./BaseModelImpl";
import { Location } from "../domain/enums/location-enum";
import { Format } from "../domain/enums/format-enum";

export class EventsModel extends BaseModelImpl<IEvents> implements IEvents {
    id: string;
    files?: IFile[];

    translations: IEventsTranslation[];
    availableLangs?: string[];

    eventDate: Date;
    location: Location;
    format: Format;

    creatorId: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IEvents) {
        super();
        this.assignData(data);
    }
}

